import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Progress } from '@/components/ui/progress';

export function DisplaySection() {
  const [progress, setProgress] = useState(33);

  return (
    <Card className='mb-8'>
      <CardHeader>
        <CardTitle>Display Components</CardTitle>
        <CardDescription>Badges, avatars, and visual elements</CardDescription>
      </CardHeader>
      <CardContent className='space-y-6'>
        <div className='space-y-4'>
          <div>
            <h4 className='text-sm font-medium mb-2'>Badges</h4>
            <div className='flex flex-wrap gap-2'>
              <Badge>Default</Badge>
              <Badge variant='secondary'>Secondary</Badge>
              <Badge variant='destructive'>Destructive</Badge>
              <Badge variant='outline'>Outline</Badge>
            </div>
          </div>

          <div>
            <h4 className='text-sm font-medium mb-2'>Avatars</h4>
            <div className='flex gap-4'>
              <Avatar>
                <AvatarImage src='https://github.com/shadcn.png' />
                <AvatarFallback>CN</AvatarFallback>
              </Avatar>
              <Avatar>
                <AvatarFallback>JD</AvatarFallback>
              </Avatar>
              <Avatar>
                <AvatarFallback>AB</AvatarFallback>
              </Avatar>
            </div>
          </div>

          <div>
            <h4 className='text-sm font-medium mb-2'>Progress</h4>
            <div className='space-y-2'>
              <Progress value={progress} className='w-full' />
              <div className='flex gap-2'>
                <Button size='sm' onClick={() => setProgress(Math.max(0, progress - 10))}>
                  Decrease
                </Button>
                <Button size='sm' onClick={() => setProgress(Math.min(100, progress + 10))}>
                  Increase
                </Button>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
